fragment EmailStats on EmailStats {
    status
    summary
    description
    descriptionLinkHtmlRef
    maxDailyEmailsCount
    emailsSentTodayCount
    emailsScheduledTodayCount
    emailsFailedCount
    automatedEmailsWillSendCount
    automatedEmailsReadyToSendCount
    automatedEmailsNeedsAttentionCount
    instanceHasConfiguredEmailAutomations
    isAutomatedSendingPaused
}
